export const  VEHICLE_INSIGHTS_PAGE={
    VEHICLE_INSIGHTS_PAGE_FETCH : "VEHICLE_INSIGHTS_PAGE_FETCH"
};
  